module.exports = __webpack_public_path__ + "img/eg3.df595e85.png";